'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/node-libs-browser/~/querystring-es3/index.js
 ** module id = 11
 ** module chunks = 0
 **/